import { countryDetailsFragment } from "@saleor/fragments/country";
import makeMutation from "@saleor/hooks/makeMutation";
import gql from "graphql-tag";

import {
  CountryBulkDelete,
  CountryBulkDeleteVariables
} from "./types/CountryBulkDelete";
import {
  CountryBulkEnable,
  CountryBulkEnableVariables
} from "./types/CountryBulkEnable";
import { CountryCreate, CountryCreateVariables } from "./types/CountryCreate";
import { CountryDelete, CountryDeleteVariables } from "./types/CountryDelete";
import { CountryUpdate, CountryUpdateVariables } from "./types/CountryUpdate";
import { RegionCreate, RegionCreateVariables } from "./types/RegionCreate";
import { RegionDelete, RegionDeleteVariables } from "./types/RegionDelete";
import { RegionUpdate, RegionUpdateVariables } from "./types/RegionUpdate";

const countryBulkDelete = gql`
  mutation CountryBulkDelete($ids: [ID!]!) {
    countryBulkDelete(ids: $ids) {
      errors: errors {
        message
      }
    }
  }
`;
export const useCountryBulkDeleteMutation = makeMutation<
  CountryBulkDelete,
  CountryBulkDeleteVariables
>(countryBulkDelete);

const countryCreate = gql`
  mutation CountryCreate($input: CountryInput!) {
    countryCreate(input: $input) {
      country {
        id
      }
      errors: countryErrors {
        field
        code
      }
    }
  }
`;

export const useCountryCreateMutation = makeMutation<
  CountryCreate,
  CountryCreateVariables
>(countryCreate);

const regionCreate = gql`
  ${countryDetailsFragment}
  mutation RegionCreate($input: RegionInput!) {
    regionCreate(input: $input) {
      country {
        ...CountryDetailsFragment
      }
      errors: countryErrors {
        field
        code
      }
    }
  }
`;

export const useRegionCreateMutation = makeMutation<
  RegionCreate,
  RegionCreateVariables
>(regionCreate);

const countryDelete = gql`
  mutation CountryDelete($id: ID!) {
    countryDelete(id: $id) {
      errors {
        message
      }
    }
  }
`;

export const useCountryDeleteMutation = makeMutation<
  CountryDelete,
  CountryDeleteVariables
>(countryDelete);

const regionDelete = gql`
  ${countryDetailsFragment}
  mutation RegionDelete($id: ID!) {
    regionDelete(id: $id) {
      country {
        ...CountryDetailsFragment
      }
      errors {
        message
      }
    }
  }
`;

export const useRegionDeleteMutation = makeMutation<
  RegionDelete,
  RegionDeleteVariables
>(regionDelete);

const countryUpdate = gql`
  ${countryDetailsFragment}
  mutation CountryUpdate($id: ID!, $input: CountryInput!) {
    countryUpdate(id: $id, input: $input) {
      country {
        ...CountryDetailsFragment
      }
      errors: countryErrors {
        field
        code
      }
    }
  }
`;

export const useCountryUpdateMutation = makeMutation<
  CountryUpdate,
  CountryUpdateVariables
>(countryUpdate);

const regionUpdate = gql`
  ${countryDetailsFragment}
  mutation RegionUpdate($id: ID!, $input: RegionInput!) {
    regionUpdate(id: $id, input: $input) {
      country {
        ...CountryDetailsFragment
      }
      errors: countryErrors {
        field
        code
      }
    }
  }
`;

export const useRegionUpdateMutation = makeMutation<
  RegionUpdate,
  RegionUpdateVariables
>(regionUpdate);

const countryBulkEnable = gql`
  mutation CountryBulkEnable($ids: [ID]!, $enable: Boolean!) {
    countryBulkEnable(ids: $ids, enable: $enable) {
      errors {
        message
      }
    }
  }
`;
export const useCountryBulkEnableMutation = makeMutation<
  CountryBulkEnable,
  CountryBulkEnableVariables
>(countryBulkEnable);
